<template>
  <PageLoading v-if="!ready" />
  <OtherAmountView v-else-if="useRedesign" />
  <OtherAmountLegacyView v-else />
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import PageLoading from "@/components/PageLoading.vue";
import OtherAmountView from "@/views/OtherAmountView.vue";
import OtherAmountLegacyView from "@/views/OtherAmountLegacyView.vue";
import authHelper from "@/helpers/authHelper";
import { isUIFlagEnabled, PAYMENT_FLOW_REDESIGN_FLAG } from "@/helpers/uiFlags";

export default defineComponent({
  name: "OtherAmountEntryView",
  components: {
    PageLoading,
    OtherAmountView,
    OtherAmountLegacyView,
  },
  setup() {
    const store = useStore();

    const useRedesign = computed<boolean>(() =>
      isUIFlagEnabled(store.state.payOptions.uiFlags, PAYMENT_FLOW_REDESIGN_FLAG),
    );

    const ready = ref<boolean>(Object.keys(store.state.payOptions.uiFlags).length > 0);

    if (!ready.value) {
      authHelper
        .getUIFlags()
        .then((flags) => {
          store.dispatch("payOptions/setUIFlags", flags);
        })
        .catch(() => undefined)
        .finally(() => {
          ready.value = true;
        });
    }

    return { ready, useRedesign };
  },
});
</script>
